import {getDenormalizedListFactory} from 'app/utils/redux_v2';

import type {
  KBArticleFeedbackSerializedType,
  KBCategorySerializedType,
} from 'sweet-types';

export const denormalizeKbCategoryList =
  getDenormalizedListFactory<KBCategorySerializedType>(
    (state) => state.kbs.categories
  );

export const denormalizeArticleFeedbackList =
  getDenormalizedListFactory<KBArticleFeedbackSerializedType>(
    (state) => state.kbs.feedback
  );
